/**
 * Shared helpers for GRN attachment/file logic.
 */

const IMAGE_PATTERN = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;

/**
 * Determines if a filename (or URL) points to an image.
 */
export const isImageFile = (filename?: string): boolean => {
  if (!filename) return false;
  return IMAGE_PATTERN.test(filename.trim());
};

/**
 * Safely parse JSON payloads stored in localStorage without throwing.
 */
export const parseJsonArray = <T = unknown>(value: string | null): T[] => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};
